// extracted by mini-css-extract-plugin
export var audioPlayer = "_qx-0";